export default "__VITE_ASSET__6uY1pxR3__"